// React
import React from 'react';

// Packages
import t from 'prop-types';

// Utilities
import { useLabels, useSearchAndFilter } from 'utilities/hooks';

// Components
import BaseCard from './_common/baseCard.js';

// Icons
import { FiCalendar } from 'react-icons/fi';

const InitiativeOverviewNextReportsDue = ({ promptKey, forceOpen }) => {
    // ///////////////////
    // HOOKS
    // ///////////////////

    const { label } = useLabels();
    const { filtered } = useSearchAndFilter({
        instanceName: 'initiatives',
    });

    // ///////////////////
    // RENDER
    // ///////////////////

    return (
        <>
            <BaseCard
                {...{
                    forceOpen,
                    title: label(
                        'AI_PromptTitle_Initiative_Overview_Next_Reports_Due'
                    ),
                    description: label(
                        'AI_PromptDescription_Initiative_Overview_Next_Reports_Due'
                    ),
                    relation: {
                        key: '',
                        id: '',
                        name: '',
                        type: '',
                    },
                    icon: FiCalendar,
                    promptKey,
                    systemPrompts: [
                        'Do not include any general heading or other headings than the sections asked for.',
                        'Do not mention object keys like "Status__c" or anything with __c in them. You may refer but not include them.',
                        'Do not ask followup questions.',
                        'The answer you provide should be in unescaped html tags for immediate parsing.',
                        'No wrapping <div>. Use <p> tags for paragraphs and <strong> for bold text and headings.',
                    ],
                    promptDataGetter: () =>
                        JSON.stringify(
                            filtered.map(initiative => ({
                                name: initiative.Name,
                                reports: initiative._reports
                                    .sort(
                                        (a, b) =>
                                            new Date(a.Due_Date__c) -
                                            new Date(b.Due_Date__c)
                                    )
                                    .filter(
                                        report =>
                                            report.Status__c !== 'Published'
                                    )
                                    .filter(
                                        report =>
                                            report.Report_Type__c !==
                                            'Milestone'
                                    )
                                    .map(report => ({
                                        type: report.Report_Type__c,
                                        dueDate: report.Due_Date__c,
                                        status: report.Status__c,
                                    })),
                            }))
                        ),
                }}
            />
        </>
    );
};

InitiativeOverviewNextReportsDue.propTypes = {
    promptKey: t.string.isRequired,
};

InitiativeOverviewNextReportsDue.defaultProps = {
    promptKey: '',
};

export default InitiativeOverviewNextReportsDue;
